import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { motion } from 'framer-motion'; // Add import statement for motion
import productImage from '../assests/profile.jpeg';
import cvFile from '../assests/UmerCV.pdf';
import Navbar from './Navbar';

const ProfileCard = () => {
  useEffect(() => {
    const bounceElement = document.querySelector('.animate-slide-short');

    const timer = setTimeout(() => {
      if (bounceElement) {
        bounceElement.classList.add('animate-stop');
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full max-w-xs mx-auto md:mx-0 flex flex-col gap-2 px-4 shadow-lg border border-blue-500 rounded-lg animate-slide-short">
      <div className="w-full flex justify-center items-center">
        <img
          className="w-32 h-32 rounded-full outline outline-offset-2 outline-2 outline-solid outline-blue-400 shadow-lg relative -top-16"
          src={productImage}
          alt="Profile"
        />
      </div>

      <div className="w-full h-full text-center flex flex-col gap-4 relative -top-10">
        <h1 className="uppercase text-lg font-semibold" style={{ color: 'white', textDecoration: 'underline' }}>
          Full Stack Developer
        </h1>

        <h2 className="text-xl font-serif capitalize font-semibold text-white">
          Umer Javed
        </h2>

        <ul className="text-white">
          <li>
            <FontAwesomeIcon icon={faEnvelope} className="mr-2 ml-1" />
            umerjutt7894@gmail.com
          </li>
          <br />
          <li>
            <FontAwesomeIcon icon={faPhone} className="mr-2 ml-1" />
            +92 (316) 547-2311
          </li>
          <br />
          <li>
            <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2 ml-1" />
            Azher town, Sohan, Islamabad
          </li>
        </ul>

        <div className="w-[60%] mx-auto flex justify-around mt-4">
          <a href="https://www.linkedin.com/in/umer-javed-844155217/" target="_blank" rel="noopener noreferrer" className="text-blue-700">
            <FontAwesomeIcon icon={faLinkedin} size="2x" />
          </a>
          <a href="https://github.com/Umer031654" target="_blank" rel="noopener noreferrer" className="text-gray-800">
            <FontAwesomeIcon icon={faGithub} size="2x" />
          </a>
        </div>
      </div>
    </div>
  );
};

const ProductDetails = () => {
  const handleContactClick = () => {
    window.open('https://wa.me/923165472311', '_blank');
  };

  return (
    <div className="container mx-auto shadow-lg rounded-md p-8">
      <section className="py-12 rounded-md" style={{ backgroundColor: '#393E46', color: 'white' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-6">
          <Navbar />
          <br />
          <div className="flex flex-col md:flex-row md:items-start md:gap-8 -mx-4">
            <div className="md:w-1/3 px-4">
              <ProfileCard />
              <div className="flex flex-col gap-4 mb-4 mt-4">
                <a href={cvFile} download className="w-full bg-blue-500 text-white py-2 px-4 rounded-full font-bold hover:bg-black flex items-center justify-center">
                  Download CV
                </a>
                <button
                  className="w-full bg-blue-500 text-white py-2 px-4 rounded-full font-bold hover:bg-black flex items-center justify-center"
                  onClick={handleContactClick}
                >
                  Contact Us
                </button>
              </div>
            </div>
            <motion.div
              initial={{ x: '100vw' }}
              animate={{ x: 0 }}
              transition={{ type: 'spring', stiffness: 120, delay: 0.5 }}
              className="md:w-2/3 px-4"
            >
              <motion.h2
                id="about"
                className="text-2xl font-bold text-white mb-2"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.5 }}
              >
                ABOUT
              </motion.h2>
              <motion.p
                className="text-gray-600 text-sm mb-4"
                style={{ color: 'white' }}
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.7 }}
              >
                Full stack developer
              </motion.p>
              <div className="mb-4">
                <span className="font-bold text-gray-700" style={{ color: 'white' }}>Recent Work</span>
              </div>
              <motion.p
                className="text-gray-600 text-sm mt-2"
                style={{ color: 'white' }}
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.9 }}
              >
                Recent graduate with a robust understanding of the MERN stack, gained through hands-on experience during a 3-month internship. Proficient in MongoDB, Express.js, React.js, and Node.js. Skilled in creating efficient and user-friendly web applications. Quick learner with a proven ability to adapt to new technologies. Eager to apply my practical experience and educational background to contribute effectively to a dynamic development team.
              </motion.p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDetails;
